import { openModal } from 'actions/modals';
import {
  setUpgradeRequested,
  setUpgradeRequestedFetching,
} from 'actions/upgrades';
import { REQUEST_UPGRADE_MODAL } from 'constants/modalTypes';
import {
  ORG_ROLE_CREATOR,
  ORG_ROLE_CREATOR_LITE,
} from 'constants/organizationRoles';
import { PLANS_AND_BILLING } from 'constants/routes';
import { UPGRADE_TYPES } from 'constants/workspaceUpgradeRequests';
import * as analytics from 'utilities/analytics';
import { getGraphQLClient } from 'utilities/graphql';
import { getUpgradeType } from 'utilities/upgrades';

import GetUpgradeWorkspaceRequestStatus from './GetUpgradeWorkspaceRequestStatus.graphql';

export const getUpgradeRequestStatus = () => {
  return async dispatch => {
    const gqlClient = getGraphQLClient();

    dispatch(setUpgradeRequestedFetching(true));

    const { data } = await gqlClient.query({
      query: GetUpgradeWorkspaceRequestStatus,
      fetchPolicy: 'no-cache',
    });

    dispatch(
      setUpgradeRequested(data.getUpgradeWorkspaceRequestStatus?.status)
    );

    dispatch(setUpgradeRequestedFetching(false));
  };
};

export const requestUpgrade = ({
  analyticsEvent,
  selectedWorkspace,
  minPlanForFeature,
}) => {
  return (dispatch, getState) => {
    const memberRole = selectedWorkspace?.memberRole;
    const requestStatus = getState().upgrades.requestStatus;

    if (analyticsEvent) {
      analytics.track(
        analyticsEvent,
        {
          userId: window.loomSSRUser.id,
          userEmail: window.loomSSRUser.email,
          workspaceId: selectedWorkspace.id,
        },
        () =>
          upgradeRequestedHandler({
            dispatch,
            memberRole,
            minPlanForFeature,
            requestStatus,
            selectedWorkspace,
          })
      );
    } else {
      upgradeRequestedHandler({
        dispatch,
        memberRole,
        minPlanForFeature,
        requestStatus,
        selectedWorkspace,
      });
    }
  };
};

const upgradeRequestedHandler = ({
  dispatch,
  memberRole,
  minPlanForFeature,
  requestStatus,
  selectedWorkspace,
}) => {
  const upgradeType = getUpgradeType({
    selectedWorkspace,
    minPlanForFeature,
  });

  if (
    memberRole === ORG_ROLE_CREATOR_LITE ||
    (memberRole === ORG_ROLE_CREATOR && upgradeType === UPGRADE_TYPES.PLAN)
  ) {
    dispatch(
      openModal(REQUEST_UPGRADE_MODAL, {
        minPlanForFeature,
        upgradeType,
        requestStatus,
      })
    );
  } else {
    window.location.href = PLANS_AND_BILLING;
  }
};
